import axios from "axios";

const instacne = axios.create({
    baseURL: "https://api.themoviedb.org/3",
});



export default instacne;